import React from 'react';
import { createRoot } from 'react-dom/client';
import { GasQueryProvider, GasToastProvider, GasConfirmProvider } from '../../shared/kit';
import App from './App';
import type { PlansListInitData } from './types';
import './style.css';

const mountEl = document.getElementById('gas-membership-plans-index-app');
if (mountEl?.dataset.reactInit && mountEl.isConnected) {
    let initData: PlansListInitData;
    try {
        initData = JSON.parse(mountEl.dataset.reactInit) as PlansListInitData;
    } catch (error) {
        mountEl.textContent = '';
        throw error;
    }

    createRoot(mountEl).render(
        <React.StrictMode>
            <GasQueryProvider>
                <GasToastProvider>
                    <GasConfirmProvider>
                        <App initData={initData} />
                    </GasConfirmProvider>
                </GasToastProvider>
            </GasQueryProvider>
        </React.StrictMode>,
    );
}
